module.exports = __webpack_public_path__ + "tb-header.svg?cfffc6e28b51ad77b78a5d56674b625f";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/tb-header.svg
// module id = 354
// module chunks = 0